/*
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import {useNavigate} from "react-router-dom";
import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import {createVenueSession} from "../../requests/AppSession";
import LoginError from "../login/LoginError";
import {useAuth} from "@workos-inc/authkit-react";
import {findVenueByCode} from "../requests/AppRequestVenueSearch";

export default function VTFindClub() {
    let navigate = useNavigate();

    const [code, setCode] = React.useState("");
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(null);

    const {getAccessToken} = useAuth();

    const submitSuccess = async responseJson => {
        setIsSubmitting(false);
        if (
            responseJson &&
            responseJson.id &&
            responseJson.name
        ) {
            await createVenueSession(
                responseJson.id,
                responseJson.name,
                responseJson.privateDancePayFeatureFlag,
                responseJson.dancePayFeatureFlag,
                responseJson.drinkPayFeatureFlag,
                responseJson.stageTipFeatureFlag,
                responseJson.venueRewardsFeatureFlag,
                responseJson.venueStripePaymentsFeatureFlag,
                responseJson.venueInputCustomerCodePaymentsFeatureFlag,
                responseJson.venueScanCustomerCodePaymentsFeatureFlag
            );

            if (responseJson.stageTipFeatureFlag) {
                navigate('/stage');
            } else if (responseJson.privateDancePayFeatureFlag || responseJson.dancePayFeatureFlag) {
                navigate('/dance/buy');
            } else if (responseJson.drinkPayFeatureFlag) {
                navigate('/dance/drink');
            } else if (responseJson.venueRewardsFeatureFlag) {
                navigate('/user/rewards');
            } else {
                navigate('/user/code');
            }
        } else {
            setErrorMessage("Club not found");
        }
    };

    const submitError = forceLogout => {
        setIsSubmitting(false);
        setErrorMessage("Club not found");
    };

    return (
        <div className="bg-white dark:bg-gray-900 py-8 sm:py-12">
            <div className="relative sm:py-8">
                <div aria-hidden="true" className="hidden sm:block">
                    <div className="absolute inset-y-0 left-0 w-1/2 rounded-r-3xl bg-gray-50 dark:bg-gray-800"/>
                    <svg className="absolute top-8 left-1/2 -ml-3" width={404} height={392} fill="none"
                         viewBox="0 0 404 392">
                        <defs>
                            <pattern
                                id="8228f071-bcee-4ec8-905a-2a059a2cc4fb"
                                x={0}
                                y={0}
                                width={20}
                                height={20}
                                patternUnits="userSpaceOnUse"
                            >
                                <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor"/>
                            </pattern>
                        </defs>
                        <rect width={404} height={392} fill="url(#8228f071-bcee-4ec8-905a-2a059a2cc4fb)"/>
                    </svg>
                </div>
                <div className="mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8">
                    <div
                        className="relative overflow-hidden rounded-2xl bg-pink-600 px-6 py-10 shadow-xl sm:px-12 sm:py-20">
                        <div aria-hidden="true" className="absolute inset-0 -mt-72 sm:-mt-32 md:mt-0">
                            <svg
                                className="absolute inset-0 h-full w-full"
                                preserveAspectRatio="xMidYMid slice"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 1463 360"
                            >
                                <path
                                    className="text-pink-500 text-opacity-40"
                                    fill="currentColor"
                                    d="M-82.673 72l1761.849 472.086-134.327 501.315-1761.85-472.086z"
                                />
                                <path
                                    className="text-pink-700 text-opacity-40"
                                    fill="currentColor"
                                    d="M-217.088 544.086L1544.761 72l134.327 501.316-1761.849 472.086z"
                                />
                            </svg>
                        </div>
                        <div className="relative">
                            <div className="sm:text-center">
                                <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                    Check-in Club
                                </h2>
                                <p className="mx-auto mt-6 max-w-2xl text-lg text-pink-200">
                                    Put in club access code
                                </p>
                            </div>
                            <div className="mt-12 sm:mx-auto sm:flex sm:max-w-lg">
                                <div className="min-w-0 flex-1">
                                    <label htmlFor="cta-email" className="sr-only">
                                        Club Access Code
                                    </label>
                                    <input
                                        name="code"
                                        type="text"
                                        value={code}
                                        maxLength={50}
                                        className="block w-full rounded-md border-0 px-5 py-3 text-base text-gray-900 placeholder-gray-500 shadow-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-pink-600"
                                        placeholder="Enter club access code"
                                        onChange={(event) => {
                                            let dvc = event.target.value;
                                            if (dvc) {
                                                dvc = dvc.toUpperCase();
                                            }
                                            setCode(dvc);
                                            setErrorMessage(null);
                                        }}
                                    />
                                </div>
                                <div className="mt-4 sm:mt-0 sm:ml-3">
                                    <button
                                        disabled={isSubmitting}
                                        className="block w-full rounded-md border-0 bg-pink-500 px-5 py-3 text-base font-medium text-white shadow hover:bg-pink-400 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-pink-600 sm:px-10"
                                        onClick={async () => {
                                            if (!code || code.trim() === "") {
                                                setErrorMessage("Club not found");
                                                return;
                                            }
                                            setIsSubmitting(true);

                                            findVenueByCode(code.trim(), submitSuccess, submitError, getAccessToken);

                                        }}
                                    >
                                        Go! {isSubmitting && <CircularProgress color="inherit" size={20}/>}
                                    </button>
                                    <div className="mt-2">
                                        {errorMessage && <LoginError errorMessage={errorMessage}/>}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
